import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38df2807"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF:", -1))
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, _toDisplayString(_ctx.queueElement.argumentName), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.queueElement.completionPercentage) + "%", 1),
    _createElementVNode("div", null, "Status: " + _toDisplayString(_ctx.queueElement.status), 1),
    (_ctx.queueElement.status === `complete`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueElement.views, (view, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createElementVNode("a", {
                  href: view.pdfUrl,
                  target: "_blank"
                }, _toDisplayString(view.pdfUrl), 9, _hoisted_3)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}